module.exports = __webpack_public_path__ + "static/media/genba-monogram-couleur.e4fbd978.svg";